/**
 *  解約用モーダルコンポーネント
 */
import commonMixin from '../mixins/_common';
import modalMixin from '../mixins/_modal';
import flashMessageMixin from '../mixins/_flash_messages';

export default {
    name: 'modal_cancellation',
    template: '#modal-cancellation-template',
    data () {
        return {
        };
    },
    props: {
        // 解約理由
        churnReasonSelect: {
            type: Object,
            required: true,
        },
        // 解約理由選択
        reason: {
            type: String,
            required: true,
        },
        // 解約理由テキスト
        text: {
            type: String,
            required: true,
        },
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin,
    ],
    emits: ['update:reason', 'update:text', 'decide'],
    computed: {
        /**
         * 解約理由選択
         */
        churnReason:  {
            get() {
                return this.reason;
            },
            set(value) {
                this.$emit('update:reason', value);
            },
        },
        /**
         * 解約理由テキスト
         */
        churnReasonText:  {
            get() {
                return this.text;
            },
            set(value) {
                this.$emit('update:text', value);
            },
        },
    },
    methods: {
        /**
         * 解約を確定する
         */
        decide() {
            this.$emit('decide');
        },
    }
};
